import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUserOrLogoutRedirect } from '../auth';
import Loader from '../lib/loader/Loader'; // Assuming you have a standard loader

const LegacyRouteRedirector: React.FC = () => {
	const location = useLocation();
	const [defaultWorkspaceSlug, setDefaultWorkspaceSlug] = useState<string | null>(
		null,
	);

	useEffect(() => {
		const fetchAndRedirect = async () => {
			const user = await getCurrentUserOrLogoutRedirect();

			// Assuming your legacy user object has the workspace info attached
			const workspaceId = user?.workspace?.slug || user?.workspace?.id || user?.workspaces?.[0]?.id;

			if (workspaceId) {
				setDefaultWorkspaceSlug(workspaceId);
			} else {
				// Fallback: If for some reason they don't have one, maybe redirect to a creation page or auth
				window.location.replace('/auth/sign-in');
			}
		};

		fetchAndRedirect();
	}, []);

	if (!defaultWorkspaceSlug) {
		return (
			<div
				style={{
					display: 'flex',
					height: '100vh',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Loader size={60} color='primary' />
			</div>
		);
	}

	// Redirect to the new workspace route, preserving the path and query params
	// Example: /editor/123 -> /ws/abc/editor/123
	return (
		<Navigate
			to={`/ws/${defaultWorkspaceSlug}${location.pathname}${location.search}`}
			replace
		/>
	);
};

export default LegacyRouteRedirector;
